export default "__VITE_ASSET__e58bdd65__"